import { useEffect, useState } from "react";
import {
  Card,
  Box,
  LinearProgress,
  Alert,
  Stack,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

import useNavStore from "../../../stores/nav";

type PlaylistVideo = {
  snippet: {
    resourceId: {
      videoId: string;
    };
  };
};

function Help() {
  const setHeaderTitle = useNavStore((state) => state.setHeader);
  const playlistId = "PLB30Ly_OJ5dc08Ggl7Mx3-PqhoI7qkwle";
  const baseUrl = "https://www.googleapis.com/youtube/v3/playlistItems";
  const [list, setList] = useState<PlaylistVideo[]>([]);
  const [progress, setProgress] = useState(true);
  const [error, setError] = useState(false);

  const getPlaylistData = async () => {
    try {
      let pageToken = "";
      const items: PlaylistVideo[] = [];

      do {
        const params = new URLSearchParams({
          key: process.env.REACT_APP_YOUTUBE_KEY || "",
          playlistId,
          part: "snippet",
          maxResults: "50",
        });

        if (pageToken) {
          params.append("pageToken", pageToken);
        }

        const response = await fetch(`${baseUrl}?${params.toString()}`, {
          method: "GET",
        });

        if (response.status !== 200) {
          setError(true);
          break;
        }

        const data = await response.json();
        if (Array.isArray(data.items)) {
          items.push(...data.items);
        }

        pageToken = data.nextPageToken || "";
      } while (pageToken);

      setList(items);
    } catch (requestError) {
      console.log(requestError);
      setError(true);
    } finally {
      setProgress(false);
    }
  };

  useEffect(() => {
    setHeaderTitle("Central de Ajuda");
    getPlaylistData();
  }, [setHeaderTitle]);

  if (progress) {
    return <LinearProgress />;
  }

  if (!progress && error) {
    return (
      <Alert
        severity="error"
        sx={{
          flexDirection: "column",
          alignItems: "center",
          textAlign: "cenrer",
        }}
      >
        <Stack spacing={2} alignItems="center" direction="column">
          <Typography textAlign="center" variant="h5">
            Ops!
          </Typography>
          <Typography textAlign="center">
            Não foi possível carregar a central de ajuda. Tente novamente mais
            tarde.
          </Typography>
        </Stack>
      </Alert>
    );
  }

  if (!progress && !error && list.length === 0) {
    return (
      <Alert
        severity="info"
        sx={{
          flexDirection: "column",
          alignItems: "center",
          textAlign: "cenrer",
        }}
      >
        <Stack spacing={2} alignItems="center" direction="column">
          <Typography textAlign="center">
            Nenhum conteúdo para listar.
          </Typography>
        </Stack>
      </Alert>
    );
  }

  return (
    <>
      <Grid container spacing={3}>
        {list.map((video) => (
          <Grid key={video.snippet.resourceId.videoId} xs={12} md={4}>
            <Card sx={{ p: 0 }}>
              <Box
                component="iframe"
                src={`https://www.youtube.com/embed/${video.snippet.resourceId.videoId}`}
                width="100%"
                height={315}
                frameBorder={0}
                allowFullScreen
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default Help;
